<template>
  <v-card
    v-if="question.description || (question.behaviors || []).length"
    class="overflow-hidden"
  >
    <v-container class="py-0">
      <v-row>
        <v-col class="my-auto text-h6 primary--text font-weight-bold">
          <div class="caption lighttext--text">{{ question.categoryName }}</div>
          {{ question.subCategoryName }}
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="my-auto">
          <v-btn icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col>
          <v-card-text class="pa-0">
            <div v-if="question.description">
              {{ question.description }}
            </div>
            <div v-if="(question.behaviors || []).length">
              <ul>
                <li v-for="behavior in question.behaviors" :key="behavior">
                  {{ behavior }}
                </li>
              </ul>
            </div>
          </v-card-text>
        </v-col>
        <v-spacer class="limited-spacer"></v-spacer>
        <inline-svg
          :width="100"
          :height="100"
          :fill="$vuetify.theme.themes.light.lighttext"
          class="badge-background"
          :src="question.badgeUrl"
          v-if="question.badgeUrl"
        />
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
  name: "SurveyQuestionTitleTooltip",
  components: { InlineSvg },
  props: { question: { type: Object } }
};
</script>

<style lang="scss" scoped>
.badge-background {
  position: absolute;
  bottom: -50px;
  right: 65px;
}

::v-deep .cls-1 {
  fill: inherit !important;
}

ul {
  list-style: none;

  li {
    padding-top: 8px;
    padding-bottom: 8px;

    &::before {
      vertical-align: bottom;
      content: "\2B24";
      color: var(--v-secondary-base);
      font-weight: bold;
      margin-left: -1em;
      margin-right: 4px;
    }
  }
}
</style>
